import { IMedia } from 'entities/MediaModel/types';

export interface ITeamContent {
  readonly id: number;
  readonly title: string;
  readonly teamMembers: ITeamMember[];
}

export interface ITeamMember {
  readonly id: number;
  readonly name: string;
  readonly jobTitle: string;
  readonly image: IMedia;
  readonly contacts?: IContact[];
}

export interface IContact {
  readonly id: number;
  readonly contact: string;
  readonly contactChannel: ContactChannel;
}

export enum ContactChannel {
  email = 'email',
  phone = 'phone',
  telegram = 'telegram',
  whatsapp = 'whatsapp',
}
